var UtilWebService = /** @class */ (function () {
    function UtilWebService() {
        var _this = this;
        this.httpGet = function (url, headers, data, isAsync, onResponse, onError) { return _this.httpRequest(url, headers, "GET", data, isAsync, onResponse, onError); };
        this.httpPost = function (url, headers, data, isAsync, onResponse, onError) { return _this.httpRequest(url, headers, "POST", data, isAsync, onResponse, onError); };
        this.httpRequest = function (url, headers, requestType, data, isAsync, onResponse, onError) {
            var xmlRequest = new XMLHttpRequest();
            var requestData = _this.headersRequireEncoding(headers)
                ? _this.encodeParams(data)
                : JSON.stringify(data);
            xmlRequest.open(requestType, url, isAsync);
            _this.setXmlHeaders(xmlRequest, headers);
            if (onError != undefined) {
                xmlRequest.onerror = onError(xmlRequest);
            }
            if (onResponse != undefined) {
                xmlRequest.onload = onResponse(xmlRequest);
            }
            xmlRequest.send(requestData);
        };
        this.setXmlHeaders = function (xmlRequest, headers) {
            Object.keys(headers).forEach(function (key) {
                xmlRequest.setRequestHeader(key, JSON.stringify(headers[key]));
            });
        };
        this.headersRequireEncoding = function (headers) {
            var contentTypeKey = "Content-Type";
            var formEncoding = "application/x-www-form-urlencoded";
            return headers.has(contentTypeKey) && headers.get(contentTypeKey) === formEncoding;
        };
        this.encodeParams = function (params) {
            var result = "";
            Object.keys(params).forEach(function (key) { return (result += key + "=" + encodeURIComponent(params[key]) + "&"); });
            return result.substr(0, result.length - 1);
        };
    }
    return UtilWebService;
}());
export var utilWebService = new UtilWebService();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilWebService.ts
// module id = 1689
// module chunks = 3